import { render, staticRenderFns } from "./time-since-last-invasion.vue?vue&type=template&id=4756ecc6&lang=pug&"
import script from "./time-since-last-invasion.vue?vue&type=script&lang=js&"
export * from "./time-since-last-invasion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports